module.exports = __webpack_public_path__ + "static/blog_guide_to_ai_features-a2bee6e3513c0eef6eba42c9477e188b.png";